const PatientGuideSection = () => {
  return (
    <section className="py-20 lg:py-32 bg-white px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <span className="text-[#007bbb] text-xs font-semibold tracking-widest uppercase">PATIENT GUIDE</span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mt-4">
            受診される方へ
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {/* 初診の方へ */}
          <div className="bg-gradient-to-br from-blue-50 to-white rounded-2xl p-8 shadow-lg border border-blue-100">
            <div className="flex items-center mb-6">
              <div className="w-12 h-12 bg-[#007bbb] rounded-full flex items-center justify-center mr-4">
                <i className="ri-user-add-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900">初診の方へ</h3>
            </div>
            <ul className="space-y-4 text-gray-700">
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-[#007bbb] mt-1 mr-3 flex-shrink-0"></i>
                <span>診療時間の<strong className="text-gray-900">30分前</strong>までにご来院ください</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-[#007bbb] mt-1 mr-3 flex-shrink-0"></i>
                <span>健康保険証を必ずお持ちください</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-[#007bbb] mt-1 mr-3 flex-shrink-0"></i>
                <span>お薬手帳をお持ちの方はご持参ください</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-[#007bbb] mt-1 mr-3 flex-shrink-0"></i>
                <span>問診票の記入がございますので、時間に余裕を持ってお越しください</span>
              </li>
            </ul>
          </div>

          {/* 他院からの転医をご希望の方へ */}
          <div className="bg-gradient-to-br from-blue-50 to-white rounded-2xl p-8 shadow-lg border border-blue-100">
            <div className="flex items-center mb-6">
              <div className="w-12 h-12 bg-[#007bbb] rounded-full flex items-center justify-center mr-4">
                <i className="ri-hospital-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900">他院からの転医をご希望の方へ</h3>
            </div>
            <ul className="space-y-4 text-gray-700">
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-[#007bbb] mt-1 mr-3 flex-shrink-0"></i>
                <span>可能であれば<strong className="text-gray-900">紹介状</strong>をご持参ください</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-[#007bbb] mt-1 mr-3 flex-shrink-0"></i>
                <span>これまでの検査結果やレントゲン写真があればお持ちください</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-[#007bbb] mt-1 mr-3 flex-shrink-0"></i>
                <span>現在服用中のお薬がある場合は、お薬手帳をご提示ください</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-[#007bbb] mt-1 mr-3 flex-shrink-0"></i>
                <span>治療経過を詳しくお聞かせいただくことで、より適切な診療が可能になります</span>
              </li>
            </ul>
          </div>

          {/* 再診の方へ */}
          <div className="bg-gradient-to-br from-blue-50 to-white rounded-2xl p-8 shadow-lg border border-blue-100">
            <div className="flex items-center mb-6">
              <div className="w-12 h-12 bg-[#007bbb] rounded-full flex items-center justify-center mr-4">
                <i className="ri-user-follow-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900">再診の方へ</h3>
            </div>
            <ul className="space-y-4 text-gray-700">
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-[#007bbb] mt-1 mr-3 flex-shrink-0"></i>
                <span>診察券と健康保険証をお持ちください</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-[#007bbb] mt-1 mr-3 flex-shrink-0"></i>
                <span>月初めの受診時には、必ず保険証をご提示ください</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-[#007bbb] mt-1 mr-3 flex-shrink-0"></i>
                <span>症状の変化や気になることがあれば、遠慮なくお伝えください</span>
              </li>
            </ul>
          </div>

          {/* その他のお願い */}
          <div className="bg-gradient-to-br from-blue-50 to-white rounded-2xl p-8 shadow-lg border border-blue-100">
            <div className="flex items-center mb-6">
              <div className="w-12 h-12 bg-[#007bbb] rounded-full flex items-center justify-center mr-4">
                <i className="ri-information-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900">その他のお願い</h3>
            </div>
            <ul className="space-y-4 text-gray-700">
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-[#007bbb] mt-1 mr-3 flex-shrink-0"></i>
                <span>住所や電話番号が変わった場合は、受付にお知らせください</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-[#007bbb] mt-1 mr-3 flex-shrink-0"></i>
                <span>混雑時はお待ちいただく場合がございます。ご了承ください</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-[#007bbb] mt-1 mr-3 flex-shrink-0"></i>
                <span>院内では携帯電話をマナーモードに設定してください</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 text-center">
          <div className="bg-blue-50 rounded-xl p-8 max-w-3xl mx-auto border border-blue-100">
            <i className="ri-heart-pulse-line text-4xl text-[#007bbb] mb-4"></i>
            <p className="text-gray-700 leading-relaxed">
              ご不明な点やご心配なことがございましたら、<br className="hidden md:block" />
              お気軽に受付スタッフまでお声がけください。<br />
              皆様のご来院を心よりお待ちしております。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PatientGuideSection;
